// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"284":"ba1712fc","893":"7bf94aed"}[chunkId] || chunkId) + "." + {"284":"99a2329ad45d3aac","567":"8e7e077d3a3af7d0","828":"92b549789ef4c1cd","893":"76a050044222113c"}[chunkId] + ".js";
};